// src/context/ThemeContext.tsx - REFACTORED
import { createContext } from "react";

// Defines the shape of the context data
export interface ThemeMetadata {
  name: string;
  label: string;
  icon: string;
}

export interface ThemeContextType {
  theme: string;
  setTheme: (theme: string) => void;
  availableThemes: ThemeMetadata[];
  // --- FIX: Removed isDark property ---
}

// Create the context with a default value
// This default is mainly for type-safety; the real value comes from the Provider.
export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);
